import React, { memo } from 'react';
import { FLEX_DIRECTION, FlexBox } from '@monorepo/ui-kit';
import isEqual from 'lodash/isEqual';

import layoutsMap from './constants';

import type { TComponentsConfig, TPage } from '@monorepo/page-builder';

import Header from '../Header';
import styles from './index.module.css';

export type LayoutProps = {
  components: TComponentsConfig;
  layout: unknown;
};

const LayoutComponent: Component<LayoutProps> = ({
  layout,
  components,
  className = ''
}) => {
  if (layoutsMap[layout.type]) {
    const Component = layoutsMap[layout.type];
    if (Component) {
      return (
        <Component
          layout={layout}
          components={components}
          className={className}
        />
      );
    }
  }
  return null;
};

type TLayoutProps = {
  page: TPage;
};

const Layout: Component<TLayoutProps> = ({ page }) => {
  const { pageConfig = {}, layout, components } = page;
  const {
    isWithHeader = true,
    isWithSubHeader = false,
    isWithStaticLayout = false,
    background
  } = pageConfig;

  const bodyClasses = `${styles.body}
    ${isWithStaticLayout ? styles.staticLayout : ''}`;

  const layoutClasses = `${styles.layout}
    ${isWithHeader && !isWithSubHeader ? styles.withHeader : ''}`;

  return (
    <>
      <FlexBox
        direction={FLEX_DIRECTION.column}
        className={bodyClasses}
        style={background ? { background } : undefined}
      >
        {isWithHeader && <Header />}
        <FlexBox direction={FLEX_DIRECTION.column} className={styles.wrap}>
          <LayoutComponent
            layout={layout}
            components={components}
            className={layoutClasses}
          />
        </FlexBox>
      </FlexBox>
    </>
  );
};

export default memo(Layout, isEqual);
